import React, { FC, createContext, useState } from 'react';
import OrganizationInconsistencyLogsResult from '../organization-logs/organization-db-inconsistency-logs/organization-db-inconsistency-logs-result';
import OrganizationDbLogsResult from '../organization-logs/organization-db-logs/organization-db-logs-result';
import OrganizationLogs from '../organization-logs/organization-logs';
import { Routes, Route } from 'react-router-dom';

type OrganizationLogsActiveTab = 'database' | 'database-inconsistency' | 'import-export';

export const OrganizationLogsContext = createContext<{
  activeTab: OrganizationLogsActiveTab;
  setActiveTab: React.Dispatch<React.SetStateAction<OrganizationLogsActiveTab>>;
}>({ activeTab: 'database', setActiveTab: () => {} });

const OrganizationsLogsIndex: FC = () => {
  const [activeTab, setActiveTab] = useState<OrganizationLogsActiveTab>('database');

  return (
    <OrganizationLogsContext.Provider value={{ activeTab, setActiveTab }}>
      <Routes>
        <Route path={`/*`} element={<OrganizationLogs />} />
        <Route path={`/inconsistency-logs/:id/`} element={<OrganizationInconsistencyLogsResult />} />
        <Route path={`/db-logs/:id/`} element={<OrganizationDbLogsResult />} />
      </Routes>
    </OrganizationLogsContext.Provider>
  );
};

export default OrganizationsLogsIndex;
